module.exports = __webpack_public_path__ + "static/media/bookhead.815e92bd.png";